// extracted by mini-css-extract-plugin
export var card = "_2-5";
export var counter = "_2-4";
export var leftInner = "_2-0";
export var spacer = "_2-1";
export var subtitle = "_2-3";
export var title = "_2-2";